export function getUniqueID(){
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function getPartImageURL(id){
  // if(part.image.name){
  //   return part.image.name;
  // }else{
  //   return './images/parts/'+part.id+'-image.png'
  // }
  if(id.includes("65-")){
    return 'https://storage.googleapis.com/web-images-parts/parts/'+id.split("65-")[1].toLowerCase()+'-image.png'
  }
  return 'https://storage.googleapis.com/web-images-parts/parts/'+id.toLowerCase()+'-image.png'
}

export function getPartDiagramURL(id){
  // if(part.diagram){
  //   return part.diagram;
  // }else{
  //   return './images/parts/'+part.id+'-diagram.png';
  // }
  if(id.includes("65-")){
    return 'https://storage.googleapis.com/web-images-parts/parts/'+id.split("65-")[1].toLowerCase()+'-diagram.png'
  }
  return 'https://storage.googleapis.com/web-images-parts/parts/'+id.toLowerCase()+'-diagram.png'
}
